import { setupServiceInfo } from '@estee/elc-universal-utils';

import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.userProfileService).register();

setupServiceInfo(__serviceInfo__);
